export const apiTimezoneIdsToLetterCodes = {
    'America/New_York': 'ET'
};
